import { render, staticRenderFns } from "./SoundsRare.vue?vue&type=template&id=5b0e3607&scoped=true&"
import script from "./SoundsRare.vue?vue&type=script&lang=js&"
export * from "./SoundsRare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e3607",
  null
  
)

export default component.exports